module.exports = __webpack_public_path__ + "static/media/male-with-desktop-icon.5423110c.png";